module.exports = __webpack_public_path__ + "static/media/jayesh_9qhQP8jcEl.9f626f75.jpg";